import { render, staticRenderFns } from "./ProductCategoryList.vue?vue&type=template&id=6bda3d9a&scoped=true&"
import script from "./ProductCategoryList.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda3d9a",
  null
  
)

export default component.exports